/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressInMonths/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ProgressInMonths({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/ProgressInMonths"
  
}) {
let treatmentProgressMonthsPassedValueData = fromData.useDataValue({ viewPath,
context: 'treatment_progress',
path: 'months_passed',
})
let constantData = '/'
let treatmentProgressTotalMonthsValueData = fromData.useDataValue({ viewPath,
context: 'treatment_progress',
path: 'total_months',
})
let constantData1 = ' months'
let aggregateData = fromAggregate.joinNoSpace(treatmentProgressMonthsPassedValueData, constantData, treatmentProgressTotalMonthsValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="semibold"
 data="treatment_progress.months_passed"
 data="'/'"
 data="treatment_progress.total_months"
 data="' months'"
 aggregate="/Simple/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}